// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daterangepicker {
    position: absolute;
    color: inherit;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ddd;
    width: 278px;
    max-width: none;
    padding: 0;
    margin-top: 7px;
    top: 100px;
    left: 20px;
    z-index: 3001;
    display: none;
    font-family: arial;
    font-size: 15px;
    line-height: 1em;
}

    .daterangepicker:before, .daterangepicker:after {
        position: absolute;
        display: inline-block;
        border-bottom-color: rgba(0, 0, 0, 0.2);
        content: '';
    }

    .daterangepicker:before {
        top: -7px;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
        border-bottom: 7px solid #ccc;
    }

    .daterangepicker:after {
        top: -6px;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        border-left: 6px solid transparent;
    }

    .daterangepicker.opensleft:before {
        right: 9px;
    }

    .daterangepicker.opensleft:after {
        right: 10px;
    }

    .daterangepicker.openscenter:before {
        left: 0;
        right: 0;
        width: 0;
        margin-left: auto;
        margin-right: auto;
    }

    .daterangepicker.openscenter:after {
        left: 0;
        right: 0;
        width: 0;
        margin-left: auto;
        margin-right: auto;
    }

    .daterangepicker.opensright:before {
        left: 9px;
    }

    .daterangepicker.opensright:after {
        left: 10px;
    }

    .daterangepicker.drop-up {
        margin-top: -7px;
    }

        .daterangepicker.drop-up:before {
            top: initial;
            bottom: -7px;
            border-bottom: initial;
            border-top: 7px solid #ccc;
        }

        .daterangepicker.drop-up:after {
            top: initial;
            bottom: -6px;
            border-bottom: initial;
            border-top: 6px solid #fff;
        }

    .daterangepicker.single .daterangepicker .ranges, .daterangepicker.single .drp-calendar {
        float: none;
    }

    .daterangepicker.single .drp-selected {
        display: none;
    }

    .daterangepicker.show-calendar .drp-calendar {
        display: block;
    }

    .daterangepicker.show-calendar .drp-buttons {
        display: block;
    }

    .daterangepicker.auto-apply .drp-buttons {
        display: none;
    }

    .daterangepicker .drp-calendar {
        display: none;
        max-width: 270px;
    }

        .daterangepicker .drp-calendar.left {
            padding: 8px 0 8px 8px;
        }

        .daterangepicker .drp-calendar.right {
            padding: 8px;
        }

        .daterangepicker .drp-calendar.single .calendar-table {
            border: none;
        }

    .daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span {
        color: #fff;
        border: solid black;
        border-width: 0 2px 2px 0;
        border-radius: 0;
        display: inline-block;
        padding: 3px;
    }

    .daterangepicker .calendar-table .next span {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
    }

    .daterangepicker .calendar-table .prev span {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
    }

    .daterangepicker .calendar-table th, .daterangepicker .calendar-table td {
        white-space: nowrap;
        text-align: center;
        vertical-align: middle;
        min-width: 32px;
        width: 32px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid transparent;
        white-space: nowrap;
        cursor: pointer;
    }

    .daterangepicker .calendar-table {
        border: 1px solid #fff;
        border-radius: 4px;
        background-color: #fff;
    }

        .daterangepicker .calendar-table table {
            width: 100%;
            margin: 0;
            border-spacing: 0;
            border-collapse: collapse;
        }

    .daterangepicker td.available:hover, .daterangepicker th.available:hover {
        background-color: #eee;
        border-color: transparent;
        color: inherit;
    }

    .daterangepicker td.week, .daterangepicker th.week {
        font-size: 80%;
        color: #ccc;
    }

    .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {
        background-color: #fff;
        border-color: transparent;
        color: #999;
    }

    .daterangepicker td.in-range {
        background-color: #ebf4f8;
        border-color: transparent;
        color: #000;
        border-radius: 0;
    }

    .daterangepicker td.start-date {
        border-radius: 4px 0 0 4px;
    }

    .daterangepicker td.end-date {
        border-radius: 0 4px 4px 0;
    }

    .daterangepicker td.start-date.end-date {
        border-radius: 4px;
    }

    .daterangepicker td.active, .daterangepicker td.active:hover {
        background-color: #357ebd;
        border-color: transparent;
        color: #fff;
    }

    .daterangepicker th.month {
        width: auto;
    }

    .daterangepicker td.disabled, .daterangepicker option.disabled {
        color: #999;
        cursor: not-allowed;
        text-decoration: line-through;
    }

    .daterangepicker select.monthselect, .daterangepicker select.yearselect {
        font-size: 12px;
        padding: 1px;
        height: auto;
        margin: 0;
        cursor: default;
    }

    .daterangepicker select.monthselect {
        margin-right: 2%;
        width: 56%;
    }

    .daterangepicker select.yearselect {
        width: 40%;
    }

    .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {
        width: 50px;
        margin: 0 auto;
        background: #eee;
        border: 1px solid #eee;
        padding: 2px;
        outline: 0;
        font-size: 12px;
    }

    .daterangepicker .calendar-time {
        text-align: center;
        margin: 4px auto 0 auto;
        line-height: 30px;
        position: relative;
    }

        .daterangepicker .calendar-time select.disabled {
            color: #ccc;
            cursor: not-allowed;
        }

    .daterangepicker .drp-buttons {
        clear: both;
        text-align: right;
        padding: 8px;
        border-top: 1px solid #ddd;
        display: none;
        line-height: 12px;
        vertical-align: middle;
    }

    .daterangepicker .drp-selected {
        display: inline-block;
        font-size: 12px;
        padding-right: 8px;
    }

    .daterangepicker .drp-buttons .btn {
        margin-left: 8px;
        font-size: 12px;
        font-weight: bold;
        padding: 4px 8px;
    }

    .daterangepicker.show-ranges .drp-calendar.left {
        border-left: 1px solid #ddd;
    }

    .daterangepicker .ranges {
        float: none;
        text-align: left;
        margin: 0;
    }

    .daterangepicker.show-calendar .ranges {
        margin-top: 8px;
    }

    .daterangepicker .ranges ul {
        list-style: none;
        margin: 0 auto;
        padding: 0;
        width: 100%;
    }

    .daterangepicker .ranges li {
        font-size: 12px;
        padding: 8px 12px;
        cursor: pointer;
    }

        .daterangepicker .ranges li:hover {
            background-color: #eee;
        }

        .daterangepicker .ranges li.active {
            background-color: #08c;
            color: #fff;
        }

/*  Larger Screen Styling */
@media (min-width: 564px) {
    .daterangepicker {
        width: auto;
    }

        .daterangepicker .ranges ul {
            width: 140px;
        }

        .daterangepicker.single .ranges ul {
            width: 100%;
        }

        .daterangepicker.single .drp-calendar.left {
            clear: none;
        }

        .daterangepicker.single.ltr .ranges, .daterangepicker.single.ltr .drp-calendar {
            float: left;
        }

        .daterangepicker.single.rtl .ranges, .daterangepicker.single.rtl .drp-calendar {
            float: right;
        }

        .daterangepicker.ltr {
            direction: ltr;
            text-align: left;
        }

            .daterangepicker.ltr .drp-calendar.left {
                clear: left;
                margin-right: 0;
            }

                .daterangepicker.ltr .drp-calendar.left .calendar-table {
                    border-right: none;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }

            .daterangepicker.ltr .drp-calendar.right {
                margin-left: 0;
            }

                .daterangepicker.ltr .drp-calendar.right .calendar-table {
                    border-left: none;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }

            .daterangepicker.ltr .drp-calendar.left .calendar-table {
                padding-right: 8px;
            }

            .daterangepicker.ltr .ranges, .daterangepicker.ltr .drp-calendar {
                float: left;
            }

        .daterangepicker.rtl {
            direction: rtl;
            text-align: right;
        }

            .daterangepicker.rtl .drp-calendar.left {
                clear: right;
                margin-left: 0;
            }

                .daterangepicker.rtl .drp-calendar.left .calendar-table {
                    border-left: none;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }

            .daterangepicker.rtl .drp-calendar.right {
                margin-right: 0;
            }

                .daterangepicker.rtl .drp-calendar.right .calendar-table {
                    border-right: none;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }

            .daterangepicker.rtl .drp-calendar.left .calendar-table {
                padding-left: 12px;
            }

            .daterangepicker.rtl .ranges, .daterangepicker.rtl .drp-calendar {
                text-align: right;
                float: right;
            }
}

@media (min-width: 730px) {
    .daterangepicker .ranges {
        width: auto;
    }

    .daterangepicker.ltr .ranges {
        float: left;
    }

    .daterangepicker.rtl .ranges {
        float: right;
    }

    .daterangepicker .drp-calendar.left {
        clear: none !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Common/css/daterangepicker.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,eAAe;IACf,UAAU;IACV,UAAU;IACV,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;IAEI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,uCAAuC;QACvC,WAAW;IACf;;IAEA;QACI,SAAS;QACT,mCAAmC;QACnC,kCAAkC;QAClC,6BAA6B;IACjC;;IAEA;QACI,SAAS;QACT,mCAAmC;QACnC,6BAA6B;QAC7B,kCAAkC;IACtC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,OAAO;QACP,QAAQ;QACR,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,OAAO;QACP,QAAQ;QACR,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;QAEI;YACI,YAAY;YACZ,YAAY;YACZ,sBAAsB;YACtB,0BAA0B;QAC9B;;QAEA;YACI,YAAY;YACZ,YAAY;YACZ,sBAAsB;YACtB,0BAA0B;QAC9B;;IAEJ;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;QAEI;YACI,sBAAsB;QAC1B;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;IAEJ;QACI,WAAW;QACX,mBAAmB;QACnB,yBAAyB;QACzB,gBAAgB;QAChB,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,iCAAiC;IACrC;;IAEA;QACI,yBAAyB;QACzB,iCAAiC;IACrC;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,6BAA6B;QAC7B,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;IAC1B;;QAEI;YACI,WAAW;YACX,SAAS;YACT,iBAAiB;YACjB,yBAAyB;QAC7B;;IAEJ;QACI,sBAAsB;QACtB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;QACzB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,sBAAsB;QACtB,YAAY;QACZ,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,iBAAiB;QACjB,kBAAkB;IACtB;;QAEI;YACI,WAAW;YACX,mBAAmB;QACvB;;IAEJ;QACI,WAAW;QACX,iBAAiB;QACjB,YAAY;QACZ,0BAA0B;QAC1B,aAAa;QACb,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,UAAU;QACV,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;QAEI;YACI,sBAAsB;QAC1B;;QAEA;YACI,sBAAsB;YACtB,WAAW;QACf;;AAER,2BAA2B;AAC3B;IACI;QACI,WAAW;IACf;;QAEI;YACI,YAAY;QAChB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;YACd,gBAAgB;QACpB;;YAEI;gBACI,WAAW;gBACX,eAAe;YACnB;;gBAEI;oBACI,kBAAkB;oBAClB,0BAA0B;oBAC1B,6BAA6B;gBACjC;;YAEJ;gBACI,cAAc;YAClB;;gBAEI;oBACI,iBAAiB;oBACjB,yBAAyB;oBACzB,4BAA4B;gBAChC;;YAEJ;gBACI,kBAAkB;YACtB;;YAEA;gBACI,WAAW;YACf;;QAEJ;YACI,cAAc;YACd,iBAAiB;QACrB;;YAEI;gBACI,YAAY;gBACZ,cAAc;YAClB;;gBAEI;oBACI,iBAAiB;oBACjB,yBAAyB;oBACzB,4BAA4B;gBAChC;;YAEJ;gBACI,eAAe;YACnB;;gBAEI;oBACI,kBAAkB;oBAClB,0BAA0B;oBAC1B,6BAA6B;gBACjC;;YAEJ;gBACI,kBAAkB;YACtB;;YAEA;gBACI,iBAAiB;gBACjB,YAAY;YAChB;AACZ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".daterangepicker {\r\n    position: absolute;\r\n    color: inherit;\r\n    background-color: #fff;\r\n    border-radius: 4px;\r\n    border: 1px solid #ddd;\r\n    width: 278px;\r\n    max-width: none;\r\n    padding: 0;\r\n    margin-top: 7px;\r\n    top: 100px;\r\n    left: 20px;\r\n    z-index: 3001;\r\n    display: none;\r\n    font-family: arial;\r\n    font-size: 15px;\r\n    line-height: 1em;\r\n}\r\n\r\n    .daterangepicker:before, .daterangepicker:after {\r\n        position: absolute;\r\n        display: inline-block;\r\n        border-bottom-color: rgba(0, 0, 0, 0.2);\r\n        content: '';\r\n    }\r\n\r\n    .daterangepicker:before {\r\n        top: -7px;\r\n        border-right: 7px solid transparent;\r\n        border-left: 7px solid transparent;\r\n        border-bottom: 7px solid #ccc;\r\n    }\r\n\r\n    .daterangepicker:after {\r\n        top: -6px;\r\n        border-right: 6px solid transparent;\r\n        border-bottom: 6px solid #fff;\r\n        border-left: 6px solid transparent;\r\n    }\r\n\r\n    .daterangepicker.opensleft:before {\r\n        right: 9px;\r\n    }\r\n\r\n    .daterangepicker.opensleft:after {\r\n        right: 10px;\r\n    }\r\n\r\n    .daterangepicker.openscenter:before {\r\n        left: 0;\r\n        right: 0;\r\n        width: 0;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n\r\n    .daterangepicker.openscenter:after {\r\n        left: 0;\r\n        right: 0;\r\n        width: 0;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n\r\n    .daterangepicker.opensright:before {\r\n        left: 9px;\r\n    }\r\n\r\n    .daterangepicker.opensright:after {\r\n        left: 10px;\r\n    }\r\n\r\n    .daterangepicker.drop-up {\r\n        margin-top: -7px;\r\n    }\r\n\r\n        .daterangepicker.drop-up:before {\r\n            top: initial;\r\n            bottom: -7px;\r\n            border-bottom: initial;\r\n            border-top: 7px solid #ccc;\r\n        }\r\n\r\n        .daterangepicker.drop-up:after {\r\n            top: initial;\r\n            bottom: -6px;\r\n            border-bottom: initial;\r\n            border-top: 6px solid #fff;\r\n        }\r\n\r\n    .daterangepicker.single .daterangepicker .ranges, .daterangepicker.single .drp-calendar {\r\n        float: none;\r\n    }\r\n\r\n    .daterangepicker.single .drp-selected {\r\n        display: none;\r\n    }\r\n\r\n    .daterangepicker.show-calendar .drp-calendar {\r\n        display: block;\r\n    }\r\n\r\n    .daterangepicker.show-calendar .drp-buttons {\r\n        display: block;\r\n    }\r\n\r\n    .daterangepicker.auto-apply .drp-buttons {\r\n        display: none;\r\n    }\r\n\r\n    .daterangepicker .drp-calendar {\r\n        display: none;\r\n        max-width: 270px;\r\n    }\r\n\r\n        .daterangepicker .drp-calendar.left {\r\n            padding: 8px 0 8px 8px;\r\n        }\r\n\r\n        .daterangepicker .drp-calendar.right {\r\n            padding: 8px;\r\n        }\r\n\r\n        .daterangepicker .drp-calendar.single .calendar-table {\r\n            border: none;\r\n        }\r\n\r\n    .daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span {\r\n        color: #fff;\r\n        border: solid black;\r\n        border-width: 0 2px 2px 0;\r\n        border-radius: 0;\r\n        display: inline-block;\r\n        padding: 3px;\r\n    }\r\n\r\n    .daterangepicker .calendar-table .next span {\r\n        transform: rotate(-45deg);\r\n        -webkit-transform: rotate(-45deg);\r\n    }\r\n\r\n    .daterangepicker .calendar-table .prev span {\r\n        transform: rotate(135deg);\r\n        -webkit-transform: rotate(135deg);\r\n    }\r\n\r\n    .daterangepicker .calendar-table th, .daterangepicker .calendar-table td {\r\n        white-space: nowrap;\r\n        text-align: center;\r\n        vertical-align: middle;\r\n        min-width: 32px;\r\n        width: 32px;\r\n        height: 24px;\r\n        line-height: 24px;\r\n        font-size: 12px;\r\n        border-radius: 4px;\r\n        border: 1px solid transparent;\r\n        white-space: nowrap;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .daterangepicker .calendar-table {\r\n        border: 1px solid #fff;\r\n        border-radius: 4px;\r\n        background-color: #fff;\r\n    }\r\n\r\n        .daterangepicker .calendar-table table {\r\n            width: 100%;\r\n            margin: 0;\r\n            border-spacing: 0;\r\n            border-collapse: collapse;\r\n        }\r\n\r\n    .daterangepicker td.available:hover, .daterangepicker th.available:hover {\r\n        background-color: #eee;\r\n        border-color: transparent;\r\n        color: inherit;\r\n    }\r\n\r\n    .daterangepicker td.week, .daterangepicker th.week {\r\n        font-size: 80%;\r\n        color: #ccc;\r\n    }\r\n\r\n    .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\r\n        background-color: #fff;\r\n        border-color: transparent;\r\n        color: #999;\r\n    }\r\n\r\n    .daterangepicker td.in-range {\r\n        background-color: #ebf4f8;\r\n        border-color: transparent;\r\n        color: #000;\r\n        border-radius: 0;\r\n    }\r\n\r\n    .daterangepicker td.start-date {\r\n        border-radius: 4px 0 0 4px;\r\n    }\r\n\r\n    .daterangepicker td.end-date {\r\n        border-radius: 0 4px 4px 0;\r\n    }\r\n\r\n    .daterangepicker td.start-date.end-date {\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .daterangepicker td.active, .daterangepicker td.active:hover {\r\n        background-color: #357ebd;\r\n        border-color: transparent;\r\n        color: #fff;\r\n    }\r\n\r\n    .daterangepicker th.month {\r\n        width: auto;\r\n    }\r\n\r\n    .daterangepicker td.disabled, .daterangepicker option.disabled {\r\n        color: #999;\r\n        cursor: not-allowed;\r\n        text-decoration: line-through;\r\n    }\r\n\r\n    .daterangepicker select.monthselect, .daterangepicker select.yearselect {\r\n        font-size: 12px;\r\n        padding: 1px;\r\n        height: auto;\r\n        margin: 0;\r\n        cursor: default;\r\n    }\r\n\r\n    .daterangepicker select.monthselect {\r\n        margin-right: 2%;\r\n        width: 56%;\r\n    }\r\n\r\n    .daterangepicker select.yearselect {\r\n        width: 40%;\r\n    }\r\n\r\n    .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {\r\n        width: 50px;\r\n        margin: 0 auto;\r\n        background: #eee;\r\n        border: 1px solid #eee;\r\n        padding: 2px;\r\n        outline: 0;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .daterangepicker .calendar-time {\r\n        text-align: center;\r\n        margin: 4px auto 0 auto;\r\n        line-height: 30px;\r\n        position: relative;\r\n    }\r\n\r\n        .daterangepicker .calendar-time select.disabled {\r\n            color: #ccc;\r\n            cursor: not-allowed;\r\n        }\r\n\r\n    .daterangepicker .drp-buttons {\r\n        clear: both;\r\n        text-align: right;\r\n        padding: 8px;\r\n        border-top: 1px solid #ddd;\r\n        display: none;\r\n        line-height: 12px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .daterangepicker .drp-selected {\r\n        display: inline-block;\r\n        font-size: 12px;\r\n        padding-right: 8px;\r\n    }\r\n\r\n    .daterangepicker .drp-buttons .btn {\r\n        margin-left: 8px;\r\n        font-size: 12px;\r\n        font-weight: bold;\r\n        padding: 4px 8px;\r\n    }\r\n\r\n    .daterangepicker.show-ranges .drp-calendar.left {\r\n        border-left: 1px solid #ddd;\r\n    }\r\n\r\n    .daterangepicker .ranges {\r\n        float: none;\r\n        text-align: left;\r\n        margin: 0;\r\n    }\r\n\r\n    .daterangepicker.show-calendar .ranges {\r\n        margin-top: 8px;\r\n    }\r\n\r\n    .daterangepicker .ranges ul {\r\n        list-style: none;\r\n        margin: 0 auto;\r\n        padding: 0;\r\n        width: 100%;\r\n    }\r\n\r\n    .daterangepicker .ranges li {\r\n        font-size: 12px;\r\n        padding: 8px 12px;\r\n        cursor: pointer;\r\n    }\r\n\r\n        .daterangepicker .ranges li:hover {\r\n            background-color: #eee;\r\n        }\r\n\r\n        .daterangepicker .ranges li.active {\r\n            background-color: #08c;\r\n            color: #fff;\r\n        }\r\n\r\n/*  Larger Screen Styling */\r\n@media (min-width: 564px) {\r\n    .daterangepicker {\r\n        width: auto;\r\n    }\r\n\r\n        .daterangepicker .ranges ul {\r\n            width: 140px;\r\n        }\r\n\r\n        .daterangepicker.single .ranges ul {\r\n            width: 100%;\r\n        }\r\n\r\n        .daterangepicker.single .drp-calendar.left {\r\n            clear: none;\r\n        }\r\n\r\n        .daterangepicker.single.ltr .ranges, .daterangepicker.single.ltr .drp-calendar {\r\n            float: left;\r\n        }\r\n\r\n        .daterangepicker.single.rtl .ranges, .daterangepicker.single.rtl .drp-calendar {\r\n            float: right;\r\n        }\r\n\r\n        .daterangepicker.ltr {\r\n            direction: ltr;\r\n            text-align: left;\r\n        }\r\n\r\n            .daterangepicker.ltr .drp-calendar.left {\r\n                clear: left;\r\n                margin-right: 0;\r\n            }\r\n\r\n                .daterangepicker.ltr .drp-calendar.left .calendar-table {\r\n                    border-right: none;\r\n                    border-top-right-radius: 0;\r\n                    border-bottom-right-radius: 0;\r\n                }\r\n\r\n            .daterangepicker.ltr .drp-calendar.right {\r\n                margin-left: 0;\r\n            }\r\n\r\n                .daterangepicker.ltr .drp-calendar.right .calendar-table {\r\n                    border-left: none;\r\n                    border-top-left-radius: 0;\r\n                    border-bottom-left-radius: 0;\r\n                }\r\n\r\n            .daterangepicker.ltr .drp-calendar.left .calendar-table {\r\n                padding-right: 8px;\r\n            }\r\n\r\n            .daterangepicker.ltr .ranges, .daterangepicker.ltr .drp-calendar {\r\n                float: left;\r\n            }\r\n\r\n        .daterangepicker.rtl {\r\n            direction: rtl;\r\n            text-align: right;\r\n        }\r\n\r\n            .daterangepicker.rtl .drp-calendar.left {\r\n                clear: right;\r\n                margin-left: 0;\r\n            }\r\n\r\n                .daterangepicker.rtl .drp-calendar.left .calendar-table {\r\n                    border-left: none;\r\n                    border-top-left-radius: 0;\r\n                    border-bottom-left-radius: 0;\r\n                }\r\n\r\n            .daterangepicker.rtl .drp-calendar.right {\r\n                margin-right: 0;\r\n            }\r\n\r\n                .daterangepicker.rtl .drp-calendar.right .calendar-table {\r\n                    border-right: none;\r\n                    border-top-right-radius: 0;\r\n                    border-bottom-right-radius: 0;\r\n                }\r\n\r\n            .daterangepicker.rtl .drp-calendar.left .calendar-table {\r\n                padding-left: 12px;\r\n            }\r\n\r\n            .daterangepicker.rtl .ranges, .daterangepicker.rtl .drp-calendar {\r\n                text-align: right;\r\n                float: right;\r\n            }\r\n}\r\n\r\n@media (min-width: 730px) {\r\n    .daterangepicker .ranges {\r\n        width: auto;\r\n    }\r\n\r\n    .daterangepicker.ltr .ranges {\r\n        float: left;\r\n    }\r\n\r\n    .daterangepicker.rtl .ranges {\r\n        float: right;\r\n    }\r\n\r\n    .daterangepicker .drp-calendar.left {\r\n        clear: none !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
